import * as React from "react";
import Dispatcher from "../../Dispatcher";
import LoadObject from "../load_objects/LoadObject";
import LoginStore from "./stores/LoginStore";
import LogoutView from "./views/LogoutView";
import { Authenticator } from "../../components/security";
import { Container } from "flux/utils";
import { ILogin } from "./records/Login";
import { Redirect } from "react-router";

interface IState
{
    loginLoader: LoadObject<ILogin>;
}

class LogoutContainer extends React.Component<{}, IState> {

    public render(): React.ReactElement<any>
    {
        return (
            <LogoutView onLogout={LogoutContainer.logout} />
        );
    }

    public static getStores()
    {
        return [
            LoginStore
        ];
    }

    public static calculateState(): IState
    {
        return {
            loginLoader: LoginStore.getState().getLoadObject()
        };
    }

    private static logout()
    {
        Dispatcher.dispatch({
            type: "logout"
        });
    }
}

export default Container.create(LogoutContainer);
